import React, { memo } from 'react';
import { ArrowDownIcon, ArrowRightIcon, CheckIcon, XIcon } from 'lucide-react';
import { StoryBox } from './StoryBox';
import { CheckEmoji } from './Emoji';
import { trackPurchaseClick } from './MetaPixel';
import { handleCheckout } from './CheckoutUtils';
export function Hero() {
  return <section className="pt-28 pb-0 bg-gradient-to-b from-amber-50 to-white" data-id="element-217">
      <div className="container mx-auto px-4" data-id="element-218">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-219">
          <div className="w-full md:w-1/2 space-y-6" data-id="element-220">
            <h1 className="text-3xl md:text-4xl font-bold text-center text-amber-800 leading-tight" style={{
            fontFamily: "'Times New Roman', Times, serif"
          }} data-id="element-221">
              "Creer que una picada increíble cuesta una fortuna es lo único que
              te está impidiendo brillar."
            </h1>
            <p className="text-xl text-center text-amber-700 font-medium" style={{
            fontFamily: "'Times New Roman', Times, serif"
          }} data-id="element-222">
              Porque cuando conocés este sistema…
            </p>
            <p className="text-lg text-center text-amber-800" style={{
            fontFamily: "'Times New Roman', Times, serif"
          }} data-id="element-223">
              …vas a armar una tabla que deslumbra sin romper el bolsillo. En
              minutos. Con lo que ya tenés.
            </p>
            <div className="mt-4" data-id="element-224">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/iqrNNxikxgTx8sSiXcKri3/picada_argentina.jpg" alt="Picada argentina completa" className="w-full h-auto rounded-lg shadow-md" data-id="element-225" />
              <div className="mt-4 flex flex-col gap-3" data-id="element-226">
                <a href="#" className="checkout-fresh bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 px-6 rounded-full shadow-md flex items-center justify-center" onClick={handleCheckout} data-id="element-227">
                  <span data-id="element-228">Quiero Aprender a Hacer Picadas</span>
                  <ArrowRightIcon size={18} className="ml-2" data-id="element-229" />
                </a>
                <button className="bg-white hover:bg-amber-50 text-amber-700 font-bold py-3 px-6 rounded-full shadow-sm border border-amber-300 flex items-center justify-center" onClick={() => {
                const testimoniosSection = document.getElementById('testimonios');
                if (testimoniosSection) {
                  testimoniosSection.scrollIntoView({
                    behavior: 'smooth'
                  });
                }
              }} data-id="element-230">
                  <span data-id="element-231">Ver Testimonios</span>
                  <ArrowRightIcon size={18} className="ml-2" data-id="element-232" />
                </button>
              </div>
              <div className="mt-6 bg-white rounded-xl shadow-md overflow-hidden border border-gray-200" data-id="element-233">
                <div className="bg-amber-500 p-4 text-white text-center" data-id="element-234">
                  <h3 className="text-xl font-bold" data-id="element-235">
                    Aprendé a armar la picada que todos te van a querer comprar…
                  </h3>
                </div>
                <div className="p-5 space-y-4" data-id="element-236">
                  <p className="text-gray-700 text-center" data-id="element-237">
                    Y convertila en tu nueva fuente de ingresos desde casa.
                  </p>
                  <div className="flex items-center gap-3" data-id="element-238">
                    <div className="bg-amber-50 rounded-full p-2.5 flex items-center justify-center w-10 h-10 flex-shrink-0 shadow-sm" data-id="element-239">
                      <span className="text-amber-500 text-lg font-semibold" data-id="element-240">
                        $
                      </span>
                    </div>
                    <p className="text-gray-700 font-medium" data-id="element-241">
                      ¿Sabías que una tabla de picada bien presentada se vende
                      por más de AR$25.000?
                    </p>
                  </div>
                  <p className="text-gray-700" data-id="element-242">
                    Ahora imaginá el poder de dominar el sistema completo:
                  </p>
                  <div className="space-y-2" data-id="element-243">
                    <div className="flex items-start gap-2" data-id="element-244">
                      <span className="text-amber-600" data-id="element-245">
                        <CheckEmoji size={20} data-id="element-246" />
                      </span>
                      <span className="text-gray-700" data-id="element-247">
                        Elegir ingredientes accesibles que parecen gourmet
                      </span>
                    </div>
                    <div className="flex items-start gap-2" data-id="element-248">
                      <span className="text-amber-600" data-id="element-249">
                        <CheckEmoji size={20} data-id="element-250" />
                      </span>
                      <span className="text-gray-700" data-id="element-251">
                        Combinar sabores que sorprenden
                      </span>
                    </div>
                    <div className="flex items-start gap-2" data-id="element-252">
                      <span className="text-amber-600" data-id="element-253">
                        <CheckEmoji size={20} data-id="element-254" />
                      </span>
                      <span className="text-gray-700" data-id="element-255">
                        Presentar como si fueras chef… sin serlo
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-700" data-id="element-256">
                    Todo desde tu cocina, con insumos simples… y mucho margen de
                    ganancia.
                  </p>
                  <p className="text-gray-700" data-id="element-257">
                    <span className="text-amber-600 font-medium" data-id="element-258">✨</span> La
                    picada no es solo para compartir.
                  </p>
                  <p className="text-gray-700" data-id="element-259">
                    Es para generar ingresos. Es para que te elijan. Y para que
                    empieces a cobrar por lo que amás hacer.
                  </p>
                  <p className="text-gray-700" data-id="element-260">
                    El secreto del armado profesional, los sabores que impactan,
                    la estética que convierte un queso y un pan en una
                    experiencia visual…
                  </p>
                  <p className="text-gray-700" data-id="element-261">
                    Ahora está al alcance de tus manos.
                  </p>
                  <div data-id="element-262">
                    <p className="text-gray-700 font-medium" data-id="element-263">
                      <span className="text-amber-600" data-id="element-264">🎯</span> Con Picadas
                      Fáciles vas a lograr:
                    </p>
                    <ul className="mt-2 space-y-2 pl-6" data-id="element-265">
                      <li className="flex items-start gap-2" data-id="element-266">
                        <span className="text-amber-600" data-id="element-267">•</span>
                        <span className="text-gray-700" data-id="element-268">
                          Picadas dignas de vitrina, sin gastar de más
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-269">
                        <span className="text-amber-600" data-id="element-270">•</span>
                        <span className="text-gray-700" data-id="element-271">
                          Recetas listas en 15 minutos
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-272">
                        <span className="text-amber-600" data-id="element-273">•</span>
                        <span className="text-gray-700" data-id="element-274">
                          Tablas que se venden solas por foto
                        </span>
                      </li>
                      <li className="flex items-start gap-2" data-id="element-275">
                        <span className="text-amber-600" data-id="element-276">•</span>
                        <span className="text-gray-700" data-id="element-277">
                          Estrategia para armar, calcular y vender picadas sin
                          experiencia previa
                        </span>
                      </li>
                    </ul>
                  </div>
                  <p className="text-gray-700 font-medium" data-id="element-278">
                    Convertí tu próxima picada en la primera venta. Porque lo
                    que hoy hacés para amigos… mañana puede pagarte las cuentas.
                  </p>
                  <div className="mt-4 text-center" data-id="element-279">
                    <button className="bg-amber-600 hover:bg-amber-700 text-white font-bold py-3 px-6 rounded-lg shadow-md transition-all flex items-center gap-2 mx-auto" onClick={() => {
                    const recetasSection = document.getElementById('recetas-exclusivas');
                    if (recetasSection) {
                      recetasSection.scrollIntoView({
                        behavior: 'smooth'
                      });
                    }
                  }} data-id="element-280">
                      <span data-id="element-281">Ir directo al producto</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-282">
                        <path d="M12 5v14" data-id="element-283"></path>
                        <path d="M19 12l-7 7-7-7" data-id="element-284"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-6" data-id="element-285">
                <div className="bg-gray-50 rounded-xl shadow-sm p-6 border border-gray-100" data-id="element-286">
                  <h3 className="text-xl md:text-2xl font-bold text-amber-700 text-center mb-4" data-id="element-287">
                    El Problema Oculto
                  </h3>
                  <p className="text-gray-600 text-center mb-6" data-id="element-288">
                    La mayoría fracasa al armar una picada realmente buena…
                    <br data-id="element-289" />
                    y ni siquiera sabe por qué.
                    <br data-id="element-290" />
                    <br data-id="element-291" />
                    Porque aunque sigan recetas, aunque compren todo lo que
                    creen que necesitan…
                    <br data-id="element-292" />
                    algo no encaja.
                  </p>
                  <div className="space-y-4 mb-6" data-id="element-293">
                    <div className="flex items-start gap-3" data-id="element-294">
                      <div className="bg-red-100 rounded-full p-1 flex-shrink-0" data-id="element-295">
                        <XIcon size={18} className="text-red-500" data-id="element-296" />
                      </div>
                      <p className="text-gray-700" data-id="element-297">
                        <span className="font-medium" data-id="element-298">
                          Los sabores no sorprenden.
                        </span>
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-299">
                      <div className="bg-red-100 rounded-full p-1 flex-shrink-0" data-id="element-300">
                        <XIcon size={18} className="text-red-500" data-id="element-301" />
                      </div>
                      <p className="text-gray-700" data-id="element-302">
                        <span className="font-medium" data-id="element-303">
                          Todo se ve pobre o improvisado, aunque haya costado
                          caro.
                        </span>
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-304">
                      <div className="bg-red-100 rounded-full p-1 flex-shrink-0" data-id="element-305">
                        <XIcon size={18} className="text-red-500" data-id="element-306" />
                      </div>
                      <p className="text-gray-700" data-id="element-307">
                        <span className="font-medium" data-id="element-308">
                          Y terminan diciendo: "La próxima mejor pido algo
                          hecho."
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="mt-6" data-id="element-309">
                    <p className="text-amber-600 font-medium" data-id="element-310">
                      <span className="mr-2" data-id="element-311">🧠</span>
                      La verdad es esta:
                    </p>
                    <p className="text-gray-700 mt-2" data-id="element-312">
                      Armar una picada memorable es una técnica profesional.
                    </p>
                    <p className="text-gray-700 mt-2" data-id="element-313">
                      Y nadie te la había enseñado así… hasta ahora.
                    </p>
                  </div>
                  <div className="mt-8 pb-2" data-id="element-314">
                    <div className="flex items-start gap-3 mb-4" data-id="element-315">
                      <span className="text-amber-500 font-bold" data-id="element-316">•</span>
                      <p className="text-gray-700" data-id="element-317">
                        Estrategia para armar, calcular y vender picadas sin
                        experiencia previa
                      </p>
                    </div>
                    <p className="text-gray-700 mb-6" data-id="element-318">
                      Convertí tu próxima picada en la primera venta. Porque lo
                      que hoy hacés para amigos... mañana puede pagarte las
                      cuentas.
                    </p>
                    <div className="flex justify-center" data-id="element-319"></div>
                  </div>
                  {/* Segundo elemento */}
                  <div className="mt-10 pt-6 border-t border-gray-200 pb-2" data-id="element-320">
                    <div className="flex items-start gap-3 mb-4" data-id="element-321">
                      <span className="text-amber-500 font-bold" data-id="element-322">•</span>
                      <p className="text-gray-700" data-id="element-323">
                        Técnicas profesionales de presentación que transforman
                        ingredientes simples en obras de arte
                      </p>
                    </div>
                    <p className="text-gray-700 mb-6" data-id="element-324">
                      Descubrí cómo crear picadas que impresionan visualmente.
                      La presentación perfecta puede duplicar el valor percibido
                      de tu creación.
                    </p>
                    <div className="flex justify-center" data-id="element-325">
                      <a href="#" className="checkout-fresh bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 px-8 rounded-full shadow-md" onClick={handleCheckout} data-id="element-326">
                        ¡Quiero Aprender! - AR$17.990
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 pt-2" data-id="element-327"></div>
          </div>
          <div className="w-full md:w-1/2" data-id="element-328"></div>
        </div>
      </div>
    </section>;
}